import { Deal } from "types/api/deal/deal";
import { ReadList } from "types/api/deal/table";

import { BaseTableV2 } from "./schemaAddOns";

// Enum equivalent of InvoiceStatusEnum
export enum InvoiceStatusEnum {
  new = "new",
  sent = "sent",
  partially_paid = "partially_paid",
  paid = "paid",
}

// InvoiceEditableBase
export interface InvoiceEditableBase {
  name: string;
  invoice_code?: string | null;
  description?: string | null;
  amount?: string | null;
  date?: string | null; // ISO date string format assumed
  status: InvoiceStatusEnum;
}

// InvoiceBase
export interface InvoiceBase extends BaseTableV2, InvoiceEditableBase {
  organization_id?: number | null;
  deal_id: number;
}

// Invoice
export interface Invoice extends InvoiceBase {
  deal: Deal;
}

// InvoiceCreate
export interface InvoiceCreate extends InvoiceEditableBase {}

// InvoiceUpdate
export interface InvoiceUpdate extends InvoiceEditableBase {
  id: string; // uuid as string
}

export interface InvoiceRead extends InvoiceBase {
  id: string;
}

export type InvoiceReadList = ReadList<InvoiceRead>;
